var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_384)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_567_384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 11.625H25.25V7.875H23.375V11.625H19.625V13.5H23.375V17.25H25.25V13.5H29V11.625ZM10.25 2.25C11.1771 2.25 12.0834 2.52492 12.8542 3.03999C13.6251 3.55506 14.2259 4.28714 14.5807 5.14367C14.9355 6.0002 15.0283 6.9427 14.8474 7.85199C14.6666 8.76127 14.2201 9.5965 13.5646 10.2521C12.909 10.9076 12.0738 11.3541 11.1645 11.5349C10.2552 11.7158 9.3127 11.623 8.45617 11.2682C7.59964 10.9134 6.86756 10.3126 6.35249 9.54174C5.83742 8.77088 5.5625 7.8646 5.5625 6.9375C5.5625 5.6943 6.05636 4.50201 6.93544 3.62294C7.81451 2.74386 9.0068 2.25 10.25 2.25ZM10.25 0.375C8.95206 0.375 7.68327 0.759884 6.60407 1.48098C5.52487 2.20208 4.68374 3.227 4.18704 4.42614C3.69034 5.62528 3.56038 6.94478 3.8136 8.21778C4.06681 9.49078 4.69183 10.6601 5.60961 11.5779C6.52739 12.4957 7.69672 13.1207 8.96972 13.3739C10.2427 13.6271 11.5622 13.4972 12.7614 13.0005C13.9605 12.5038 14.9854 11.6626 15.7065 10.5834C16.4276 9.50423 16.8125 8.23544 16.8125 6.9375C16.8125 5.19702 16.1211 3.52782 14.8904 2.29711C13.6597 1.0664 11.9905 0.375 10.25 0.375ZM19.625 26.625H17.75V21.9375C17.75 20.6943 17.2561 19.502 16.3771 18.6229C15.498 17.7439 14.3057 17.25 13.0625 17.25H7.4375C6.1943 17.25 5.00201 17.7439 4.12294 18.6229C3.24386 19.502 2.75 20.6943 2.75 21.9375V26.625H0.875V21.9375C0.875 20.197 1.5664 18.5278 2.79711 17.2971C4.02782 16.0664 5.69702 15.375 7.4375 15.375H13.0625C14.803 15.375 16.4722 16.0664 17.7029 17.2971C18.9336 18.5278 19.625 20.197 19.625 21.9375V26.625Z",
    fill: "#383838"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_567_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.b31b95276a4c8df8f9843bc715b7f6d0.svg";
export { ForwardRef as ReactComponent };